<script>
  import {url} from '@sveltech/routify';
  import Tooltip from "../../UI/Tooltip.svelte";
  import duracion from '../../../Utils/duracion';

  export let trabajador = null;

  let avisoVisible = false, estado, advertencia, sinFichar, enlace, ultimaHora;

  $: {
    if (!trabajador.marcaje || trabajador.marcaje.horas.length === 0) {
      sinFichar = true;
      estado = 'No ha fichado hoy';
    } else {
      const horas = trabajador.marcaje.horas,
          dia = trabajador.marcaje.fecha;

      ultimaHora = horas[horas.length - 1];

      enlace = $url(`/trabajadores/${trabajador.trabajador.id}/marcajes/${dia.split('-').reverse().join('-')}`);
    }
  }
</script>

<style>
    .fila {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
    }

    .nombre {
        padding-right: 1em;
        margin-right: auto;
    }

    .aviso {
        --color: var(--acentos);
        position: relative;
        margin-left: .5em;
    }

    .aviso i {
        color: #f00;
        cursor: default;
    }

    a {
        color: currentColor;
        font-weight: 500;
    }

    a:not(:hover) {
        text-decoration: none;
    }
</style>

<div class="fila">
    <div class="nombre">
        <a href={$url(`/trabajadores/${trabajador.trabajador.id}`)}>
            {trabajador.trabajador.apellidos}, {trabajador.trabajador.nombre}
        </a>
    </div>

    <div class="estado">
        {#if sinFichar}
            No ha fichado hoy
        {:else}
            <a href={enlace}><strong>{ultimaHora.motivo.nombre}</strong> desde hace {duracion(trabajador.diferencia)}</a>
        {/if}
    </div>

    {#if trabajador.aviso}
        <div class="aviso">
            <i class="material-icons" on:mouseover={() => avisoVisible = true}
               on:mouseleave={() => avisoVisible = false}>warning</i>

            {#if avisoVisible}
                <Tooltip>{@html trabajador.aviso}</Tooltip>
            {/if}
        </div>
    {/if}
</div>